import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {ConnectedPosition, OverlayModule} from '@angular/cdk/overlay';
import {MarkdownComponent} from '../../../../../shared/components/markdown/markdown.component';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';
import {NgFor, NgIf} from '@angular/common';
import {WebInsight, WebInsights} from '../../../types';

type WebInsightSource = WebInsight['sources'][number];

const PREVIEW_CLOSE_DELAY_MS = 150;

@Component({
  selector: 'app-copilot-web-insights-message',
  imports: [
    MarkdownComponent,
    NgIf,
    NgFor,
    AssetVersionPipe,
    OverlayModule
  ],
  templateUrl: './copilot-web-insights-message.component.html',
  styleUrl: './copilot-web-insights-message.component.scss'
})
export class CopilotWebInsightsMessageComponent implements OnChanges, OnDestroy {
  @Input() webInsights: WebInsights | string | undefined;

  isLegacy = false;
  legacyContent = '';
  insightItems: WebInsight[] = [];
  hoveredSource: WebInsightSource | null = null;
  private closePreviewTimeout: ReturnType<typeof setTimeout> | undefined;

  readonly previewPositions: ConnectedPosition[] = [
    {originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 4},
    {originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -4},
  ];

  ngOnChanges(): void {
    this.isLegacy = false;
    this.legacyContent = '';
    this.insightItems = [];
    const value = this.webInsights;
    if (Array.isArray(value)) {
      this.insightItems = value;
      return;
    }
    if (typeof value !== 'string') {
      return;
    }
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        this.insightItems = parsed;
        return;
      }
    } catch {}
    this.isLegacy = true;
    this.legacyContent = value;
  }

  openPreview(source: WebInsightSource): void {
    clearTimeout(this.closePreviewTimeout);
    this.hoveredSource = source;
  }

  scheduleClosePreview(): void {
    clearTimeout(this.closePreviewTimeout);
    this.closePreviewTimeout = setTimeout(() => this.hoveredSource = null, PREVIEW_CLOSE_DELAY_MS);
  }

  ngOnDestroy(): void {
    clearTimeout(this.closePreviewTimeout);
  }
}
